import { AuthOrganizationsCard } from "@components/Cards";

export const AuthOrganizations = () => {
  return <AuthOrganizationsCard />;
};
